import { Box, Link, Typography } from "@mui/material";
import "../_style.scss";
import TkButton from "../../../components/atoms/TkButton";
import {
  InquiryResultDisplayType,
  Prefectures,
  SexFlug,
  TransitionalCode,
} from "../../../assets/data/Constants";
import { TkGetCode } from "../../../utils/TkGetCode";
import { SearchResultList } from "../../../type/apiType/IAPI_INQ001";

/**
 * レスポンスデータをテーブルデータに変換する
 * @param res レスポンスデータ
 * @param handleLink 遷移するイベント
 * @param handBtn 詳細ボタン押下イベント
 * @param resultType 検索結果表示対象
 * @returns テーブルデータ
 */
function funInfoBodyList(
  list: SearchResultList[],
  handleLink: (path: string, state: {}) => void,
  handBtn: (
    contractorNo: string,
    resultType: InquiryResultDisplayType,
    facilityNo?: string,
    detailDisplayCd?: string
  ) => void,
  resultType: InquiryResultDisplayType
) {
  const infoBodyList = list?.map((item) => [
    {
      children: (
        <Box>
          <Typography>
            <Link
              data-testid="SCRW120002TableDataContractorLinkForTest"
              onClick={() =>
                handleLink("/SCRC040101", {
                  contractorNo: item.contractorNo,
                })
              }
            >
              {(item.contractorNo ?? "") + ":" + (item.corpName ?? "")}
            </Link>
          </Typography>
          {(resultType === InquiryResultDisplayType["施設"] ||
            resultType === InquiryResultDisplayType["職員"]) &&
            item.facilityNo !== null &&
            item.facilityName !== null && (
              <Typography>
                <Link
                  data-testid="SCRW120002TableDataFacilityLinkForTest"
                  onClick={() =>
                    handleLink("/SCRW120004", {
                      contractorNo: item.contractorNo,
                      facilityNo:
                        item.facilityNo !== null ? item.facilityNo : "",
                    })
                  }
                >
                  {(item.facilityNo ?? "") + ":" + (item.facilityName ?? "")}
                </Link>
              </Typography>
            )}
        </Box>
      ),
      align: "left",
      forSort: item.contractorNo,
    },
    {
      children: (
        <Box>
          <Typography>
            {(TkGetCode(Prefectures, item.coprefectureCd) ?? "") +
              (item.coaddressCity ?? "") +
              (item.coaddressOthers ?? "")}
          </Typography>
          {(resultType === InquiryResultDisplayType["施設"] ||
            resultType === InquiryResultDisplayType["職員"]) &&
            item.prefectureCd !== null &&
            item.addressCity !== null &&
            item.addressOthers !== null && (
              <Typography>
                {(TkGetCode(Prefectures, item.prefectureCd) ?? "") +
                  (item.addressCity ?? "") +
                  (item.addressOthers ?? "")}
              </Typography>
            )}
        </Box>
      ),
      align: "left",
    },
    {
      children:
        resultType === InquiryResultDisplayType["施設"] ||
        resultType === InquiryResultDisplayType["職員"] ? (
          <Box>
            <Typography>{item.facilityTypeName}</Typography>
            <Typography>{item.facilityClassName}</Typography>
            <Typography>
              {item.bReformEstablishmentFlg === "1" ? "◎" : ""}
            </Typography>
          </Box>
        ) : (
          <></>
        ),
      align: "left",
    },
    {
      children:
        resultType === InquiryResultDisplayType["職員"] ? (
          item.staffNo !== null &&
          item.staffNameKanji !== null &&
          item.birthday !== null &&
          item.sex !== null && (
            <Box data-testid="SCRW120002TableDataStaffBox1ForTest">
              <Link
                data-testid="SCRW120002TableDataStaffLinkForTest"
                onClick={() =>
                  handleLink("/SCRW120005", {
                    contractorNo: item.contractorNo,
                    facilityNo: item.facilityNo,
                    staffNo: item.staffNo,
                  })
                }
              >
                {`${item.staffNo ?? ""}:${item.staffNameKanji}${
                  TransitionalCode[
                    item.transitionalCode as keyof typeof TransitionalCode
                  ] ?? ""
                }`}
              </Link>
              <Typography>
                {(item.birthday ?? "") +
                  "　" +
                  (TkGetCode(SexFlug, item.sex) ?? "")}
                　
              </Typography>
            </Box>
          )
        ) : (
          <></>
        ),
      align: "left",
    },
    {
      children:
        resultType === InquiryResultDisplayType["職員"] ? (
          <Box data-testid="SCRW120002TableDataStaffBox2ForTest">
            <Typography>{item.firstJoinDate}</Typography>
            <Typography>{item.retireDate}</Typography>
          </Box>
        ) : (
          <></>
        ),
      align: "center",
    },
    {
      children: (
        <TkButton
          role="SCRW120002TableDataFacilityButtonForTest"
          onClick={() =>
            handBtn(
              item.contractorNo!,
              InquiryResultDisplayType["施設"],
              undefined,
              "1"
            )
          }
        >
          詳細
        </TkButton>
      ),
      align: "center",
    },
    {
      children: (
        <TkButton
          role="SCRW120002TableDataStaffButtonForTest"
          onClick={() =>
            handBtn(
              item.contractorNo!,
              InquiryResultDisplayType["職員"],
              item.facilityNo,
              item.facilityNo ? "3" : "2"
            )
          }
        >
          詳細
        </TkButton>
      ),
      align: "center",
    },
  ]);

  return infoBodyList ?? [];
}

export { funInfoBodyList };
